export default class DecryptagePedagogicArticle {
  constructor({
    title, thumbnail, link, chapo,
  }) {
    this.title = title;
    this.thumbnail = thumbnail;
    this.link = link;
    this.chapo = chapo;
  }

  getTitle() {
    return this.title;
  }

  getThumbnail() {
    return this.thumbnail;
  }

  getLink() {
    return this.link;
  }

  getChapo() {
    return this.chapo;
  }
}
